import script from "./TourForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./TourForm.vue?vue&type=script&setup=true&lang=ts"

import "./TourForm.vue?vue&type=style&index=0&id=7b351d71&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b351d71"]])

export default __exports__